import { useGetQuery } from 'common/hooks';
import { ApiPaths } from '../constants/apiPaths';
import { APICalendarMeetingTemplateSchema } from './useCreateCalendarMeetingTemplate';
import { UseUserCalendarReturnData } from '../hooks/useUserCalendar';
import { mapFetchCalendarMeetingTemplate } from '../utils/mapFetchCalendarMeetingTemplate';
import { getUnresolvedTemplateParticipants } from '../utils/getUnresolvedTemplateParticipants';

type Props = {
  id: string | undefined;
  userCalendars: UseUserCalendarReturnData;
};

export const useFetchCalendarMeetingTemplate = ({
  id,
  userCalendars
}: Props) => {
  const { data, isLoading, isError } =
    useGetQuery<APICalendarMeetingTemplateSchema>(
      `${ApiPaths.GET_CALENDAR_MEETING_TEMPLATE}/${id}`,
      {
        enabled: id !== undefined && userCalendars.length > 0,
        queryKey: [ApiPaths.GET_CALENDAR_MEETING_TEMPLATE, id]
      }
    );

  if (!data || !userCalendars) {
    return {
      data: undefined,
      isLoading,
      isError,
      unresolvedParticipants: [],
      hasStoredOutreachSettings: false
    };
  }

  const mappedData = mapFetchCalendarMeetingTemplate(data, userCalendars);

  return {
    data: mappedData,
    isLoading,
    isError,
    unresolvedParticipants: getUnresolvedTemplateParticipants(
      data,
      userCalendars
    ),
    // mapFetch seeds a default, so only the raw response knows if it had one.
    hasStoredOutreachSettings:
      typeof data.availabilityOutreachSettings?.requiredHours === 'number'
  };
};
